// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"0e2a74eb","96":"0824796b","233":"a0306c70","453":"9444281c","469":"02cd03c5","532":"35d0e9aa","731":"03b4e017"}[chunkId] + ".chunk.js";
};